/* global Dropzone */
/* global $ */
/* global gettext */
/* global sculpteoJob */
/* global sculpteoNotification */

Dropzone.autoDiscover = false;

var error_messages = {
  not_supported: gettext(
    'We detected your file as "{{format}}" but we do not support this file format yet.'
  ),

  not_supported_medical: gettext(
    "This file format is not supported for medical designs. Please use one of the following formats: {{formats}}"
  ),
};

(function (sculpteo) {
  "use strict";

  var UploadController = (sculpteo.UploadController = function (options) {
    this.knownFiles = {};
    this.archives = {};
    this.defaults = {
      multiUpload: true,
      filesizeBase: 1024, // 1 KibiByte = 1024 Bytes (current dropzone 3.8.3 only supports Kibi)
    };

    this.options = $.extend(this.defaults, options || {});
    this.dropzone = null;
    this.isMedical = false;

    this.$uploadHeader = $(".upload-header");

    this.uuids = [];
    this.$uuids = $("[name=progressUuid]");
    this.s3Keys = [];

    this.fileUpload = 0;

    this.$list = $("#upload-files");
    this.$uploadFilesHeader = $(".upload-files-header");
    this.$designStudioContact = $(".design-studio-contact");
    this.$template = $("#uploaded-file-template");
    this.$form = $("#upload-file");
    this.$medicalCheckbox = $("#id_is_medical");

    this.$uploadOptionsVisibility = $("#upload-options-visibility");
    this.$uploadLaserFormat = $("#laser-format");
    this.$uploadPrintingFormat = $("#printing-format");
    this.$uploadMedicalPrintingFormat = $("#printing-format-medical");

    this.$uploadOptionsVisibilityCheckbox = $("#id_print_authorization");
    this.$uploadOptionsUnit = $("#upload-options-unit");

    this.rootUUID = "";

    this.$blockUpload = $(".upload_block");
    this.$blockUploadInner = $(".upload_block-inner");
    this.$uploadOptions = $(".upload-options");
    this.$blockButtons = $(".buttons_block");
    this.$buttons_block_process = $(
      ".buttons_block-process",
      this.$blockButtons
    );

    this.$blockButtons.on(
      "click",
      "[data-btn-addmore]",
      this.showUploadBlock.bind(this)
    );
    this.$blockButtons.on(
      "click",
      ".buttons_block-process:not(.disabled) [data-btn-process]",
      this.process.bind(this)
    );

    this.$uploadHeader.on(
      "change",
      "input[type=radio][name=privacy]",
      this.uploadOptionsPrivacyChanged.bind(this)
    );

    this.onDrop = false;
    $(document).on("dragover", this.onDropFiles.bind(this));

    sculpteoNotification("import_progress").recv(
      this.onProcessNotification.bind(this)
    );

    this.initializeDropzone();

    $("#uploadFile").on("click", function () {
      if (window.tagCommander) {
        window.tagCommander.sendTag(null, "upload", { clic_origin: "button" });
      }
    });

    $("#uploadFile").on("drop", function () {
      if (window.tagCommander) {
        window.tagCommander.sendTag(null, "upload", { clic_origin: "drop" });
      }
    });
    this.isMedical = this.$medicalCheckbox.is(":checked");
    this.isMedicalChanged();

    this.$medicalCheckbox.on(
      "change",
      function () {
        this.isMedical = this.$medicalCheckbox.is(":checked");
        this.isMedicalChanged();
      }.bind(this)
    );

    $("#id_not_a_medical_device").on("click", function (event) {
      event.preventDefault();
      $("#not-a-medical-device-modal").show();
      $("#upload-file").addClass("disable-form");
    });
    $("#not-a-medical-device-modal")
      .find("[name=close-modal]")
      .on("click", function () {
        $("#not-a-medical-device-modal").hide();
        $("#upload-file").removeClass("disable-form");
      });

    const $fileFormatWindow3d = $("#file-format-window-3d");
    const $fileFormatWindowLaser = $("#file-format-window-laser");
    const $fileFormatWindowMedical = $("#file-format-window-medical");

    const $rotateIcon3d = $("#rotate-icon-3d-printing");
    const $rotateIconLaser = $("#rotate-icon-laser");
    const $rotateIconMedical = $("#rotate-icon-3d-printing-medical");

    const $uploadPrintingFormat = $("#printing-format");
    const $uploadLaserFormat = $("#laser-format");
    const $uploadMedicalPrintingFormat = $("#printing-format-medical");

    function toggleFileFormatWindow(
      $uploadButton,
      $rotateIcon,
      $fileFormatWindow
    ) {
      $uploadButton.on("click", function (event) {
        $rotateIcon.toggleClass("rotated");

        if (
          $fileFormatWindow.css("display") === "none" ||
          $fileFormatWindow.css("display") === ""
        ) {
          $fileFormatWindow.css("display", "block");

          const iconRect = $rotateIcon[0].getBoundingClientRect();

          $fileFormatWindow.css("left", `${iconRect.left + window.scrollX}px`);

          const spacing = 100;
          $fileFormatWindow.css(
            "top",
            `${
              iconRect.top +
              window.scrollY -
              $fileFormatWindow.outerHeight() -
              spacing
            }px`
          );

          $(document).on("click", closeWindowOnOutsideClick);
        } else {
          $fileFormatWindow.css("display", "none");
          $(document).off("click", closeWindowOnOutsideClick);
        }

        event.stopPropagation();
      });
      $fileFormatWindow.on("click", function (event) {
        event.stopPropagation();
      });
    }

    function closeWindowOnOutsideClick(event) {
      toggleCloseWindow($fileFormatWindow3d, $rotateIcon3d, event);
      toggleCloseWindow($fileFormatWindowLaser, $rotateIconLaser, event);
      toggleCloseWindow($fileFormatWindowMedical, $rotateIconMedical, event);
    }

    function toggleCloseWindow($fileFormatWindow, $rotateIcon, event) {
      if (
        !$fileFormatWindow[0].contains(event.target) &&
        event.target !== $rotateIcon[0]
      ) {
        $fileFormatWindow.css("display", "none");
        $(document).off("click", closeWindowOnOutsideClick);
        $rotateIcon.removeClass("rotated");
      }
    }

    toggleFileFormatWindow(
      $uploadPrintingFormat,
      $rotateIcon3d,
      $fileFormatWindow3d
    );
    toggleFileFormatWindow(
      $uploadLaserFormat,
      $rotateIconLaser,
      $fileFormatWindowLaser
    );
    toggleFileFormatWindow(
      $uploadMedicalPrintingFormat,
      $rotateIconMedical,
      $fileFormatWindowMedical
    );
  });

  UploadController.prototype.isMedicalChanged = function () {
    // Toggle visibility of certain elements with medical version
    this.$blockUploadInner.toggleClass("medical", this.isMedical);
    this.$uploadOptionsVisibility.toggleClass(
      "unavailable-for-medical",
      this.isMedical
    );
    this.$uploadOptionsUnit.toggleClass("medical-border", this.isMedical);

    const toggleVisibility = (element, condition) => element.toggle(condition);
    toggleVisibility(this.$uploadLaserFormat, !this.isMedical);
    toggleVisibility(this.$uploadPrintingFormat, !this.isMedical);
    toggleVisibility(this.$uploadMedicalPrintingFormat, this.isMedical);

    this.$uploadOptionsVisibilityCheckbox
      .prop("checked", false)
      .prop("disabled", this.isMedical);

    // Update file format restrictions in the file dialog
    // c.f https://stackoverflow.com/questions/37510204/dropzone-change-acceptedfiles-dynamically
    if (this.isMedical) {
      this.dropzone.hiddenFileInput.setAttribute(
        "accept",
        this.options.supportedFileExtensionsMedical.join(", ")
      );
      this.dropzone.options.maxFiles = 30;
    } else {
      this.dropzone.hiddenFileInput.setAttribute(
        "accept",
        this.options.supportedFileExtensions.join(", ")
      );
      this.dropzone.options.maxFiles = 30;
    }
  };

  UploadController.prototype.initializeDropzone = function () {
    // uploadFile correspond to the DOM id of the element
    Dropzone.options.uploadFile = {
      maxFiles: this.options.multiUpload ? 30 : 1,
      //filesizeBase: this.options.filesizeBase, (that setting is ignored by dropzone 3.8.3, reconsider when we update)
      dictMaxFilesExceeded: gettext(
        "You can only upload {{maxFiles}} files at the same time. Try uploading an archive or .zip of your files instead."
      ),
      parallelUploads: 3,
      uploadMultiple: false,
      addRemoveLinks: false,
      createImageThumbnails: false,
      dictDefaultMessage:
        '<div class="drop-zone-container">' +
        "<div></div>" +
        '<div class="upload-section">' +
        '<div class="icon-upload"></div>' +
        '<div class="uploadText">' +
        gettext("Select file for upload") +
        "</div>" +
        "</div>" +
        '<div class="details-section">' +
        "<div>" +
        '<div class="icon-drop"></div>' +
        '<div class="uploadSubText">' +
        gettext("Drop your 3D / 2D file") +
        "</div>" +
        "</div>" +
        "<div>" +
        '<div class="icon-confidential"></div>' +
        '<div class="uploadSubText">' +
        gettext("All files are confidential") +
        "</div>" +
        "</div>" +
        "<div>" +
        '<div class="icon-maxsize"></div>' +
        '<div class="uploadSubText">' +
        gettext("Maximum file size: 125 Mo") +
        "</div>" +
        "</div>" +
        "</div>" +
        "</div>",

      dictFileTooBig: gettext(
        "File is too big ({{filesize}}MB). Please try to reduce it to a size below {{maxFilesize}}MB. If not possible, please contact us!"
      ),
      //dictResponseError: gettext("Server responded with {{statusCode}} code."),  // This doesn't seem to work c.f below
      dictInvalidFileType: gettext("Unsupported file format."),
      dictCancelUpload: " ",
      dictCancelUploadConfirmation: gettext(
        "Are you sure you want to cancel this upload?"
      ),
      dictRemoveFile: " ",
      dictRemoveFileConfirmation: gettext(
        "Are you sure you want to remove this file?"
      ),
      forceFallback: false,
      acceptedFiles: this.options.supportedFileExtensions.join(", "),

      previewTemplate: this.$template.html(),
      previewsContainer: "#upload-files",
      headers: {
        "X-CSRFToken": $('input[name="csrfmiddlewaretoken"]', this.$form).val(),
      },
      accept: function (file, done) {
        if (file.type == "import_progress") {
          return;
        } else {
          return done();
        }
      },
    };

    this.dropzone = new Dropzone("#uploadFile");

    this.dropzone.on(
      "sending",
      function (file, xhr, formData) {
        if (file.s3Data) {
          for (var prop in file.s3Data) {
            formData.append(prop, file.s3Data[prop]);
          }
        } else {
          formData.append("medical", Number(this.isMedical));
        }
      }.bind(this)
    );

    this.dropzone.on("addedfile", this.onFileAdded.bind(this));
    this.dropzone.on("success", this.onFileUploaded.bind(this));
    this.dropzone.on("uploadprogress", this.onFileProgress.bind(this));
    this.dropzone.on("error", this.onFileError.bind(this));
    this.dropzone.on("removedfile", this.onFileRemoved.bind(this));
    this.dropzone.on("maxfilesexceeded", this.onMaxFilesExceeded.bind(this));
  };

  /**
   * called when dragging new files on the dropzone
   * will show the zone and button if trying to drop a file and only a file
   *
   */
  UploadController.prototype.onDropFiles = function (e) {
    var dt = e.originalEvent.dataTransfer;
    if (
      dt.types &&
      (dt.types.indexOf
        ? dt.types.indexOf("Files") != -1
        : dt.types.contains("Files"))
    ) {
      if (
        !this.onDrop &&
        this.fileUpload != 0 &&
        this.$blockUpload.css("display") == "none"
      ) {
        this.showUploadBlock();
        this.onDrop = true;
      }
    }
  };

  /**
   * called when we are trying to upload a file when the limit is reached
   * actual limit is 30
   *	Removed last file upload
   */
  UploadController.prototype.onMaxFilesExceeded = function (file) {
    $(".limit-files-error-message").show();
    this.dropzone.removeFile(file);
  };

  /**
   * Dropzone file added callback.
   * Let's ensure that the file list is visible and complete content a bit
   *
   * @param {Object} file
   */
  UploadController.prototype.onFileAdded = function (file) {
    // hide studio contact
    this.$designStudioContact.hide();

    // display the list on uploaded files
    this.$list.show();

    // display the header
    this.$uploadFilesHeader.show();

    if (this.dropzone.element.dataset.presignedUrl) {
      $.ajax({
        url: this.dropzone.element.dataset.presignedUrl,
        data: {
          medical: Number(this.isMedical),
          filename: file.name,
        },
        async: false,
        success: function (response) {
          var data = JSON.parse(response);
          file.s3Data = data.fields;
        },
      });
    }

    //reset the value, allow another drag and drop
    this.onDrop = false;

    // For remaining time computation. See onFileProgress()
    file.startTime = new Date().getTime();

    // Setting design name (only for first design)
    var designname = file.name;
    designname = designname.substring(0, designname.lastIndexOf("."));

    if (designname.lastIndexOf("/") != -1) {
      designname = designname.substring("/", designname.length);
    }
    if (designname.lastIndexOf("\\") != -1) {
      designname = designname.substring(
        designname.lastIndexOf("\\") + 1,
        designname.length
      );
    }
    designname = designname.substring(0, 64);

    if ($("#id_name").val().length === 0) {
      $("#id_name").val(designname);
      $("[name=filename]").val(file.name);
    }

    var $row = $(file.previewTemplate);
    $row.data("name", file.name);
    if (file.uuid) $row.uuid = file.uuid;
    $row._name = file.name;
    $row.filePct = 0;
    if (file.archive) {
      $("[data-dz-name]", $row).text(file.archive + ": " + file.name);
    }

    $(".upload_file-remove a", $row).on(
      "click",
      function (e) {
        // Make sure the button click doesn't submit the form:
        e.preventDefault();
        e.stopPropagation();

        // Remove the file.
        this.dropzone.removeFile(file);
        if (window.GoogleTagManager) {
          // send tag to TGM
          window.GoogleTagManager.sendTag({
            category: "upload",
            action: "remove",
          });
        }
      }.bind(this)
    );

    //hide buttons upload
    //this.$blockUpload.hide();
    this.$uploadOptions.hide();
    //show the buttons add more design + process design on the top
    $(".buttons_block-bottom").show();

    //disable the button until the upload is finished
    this.$buttons_block_process.addClass("disabled");

    if (this.dropzone.files.length >= 2) {
      // Display the button "add more design"
      $(".buttons_block-top").show();
    }
    //adding the file to the list of known ones
    if (file.uuid) {
      this.knownFiles[file.name + file.uuid] = $row;
    } else {
      this.knownFiles[file.name] = $row;
    }
    if (window.GoogleTagManager) {
      // send tag to TGM
      window.GoogleTagManager.sendTag({
        category: "upload",
        action: "dropzone",
      });
    }
  };

  UploadController.prototype.onFileRemoved = function (file) {
    //removing the file from various maps
    if (this.knownFiles[file.name]) delete this.knownFiles[file.name];
    if (this.knownFiles[file.name + file.uuid])
      delete this.knownFiles[file.name + file.uuid];
    if (this.archives[file.name]) delete this.archives[file.name];
    //removed
    this.fileUpload = this.dropzone.files.length;

    //set this.uuids with the remaining uuids of the files
    this.uuids = [];
    for (var i = 0; i < this.dropzone.files.length; i++) {
      //push only the remaining file on the uuids
      if (this.dropzone.files[i].s3Data) {
        this.uuids.push(this.dropzone.files[i].s3Data.key);
      } else {
        this.uuids.push(JSON.parse(this.dropzone.files[i].xhr.response).key);
      }
    }
    this.$uuids.val(this.uuids.join(","));

    //hide the button on the bottom if there is less than 2 files
    if (this.dropzone.files.length < 2) {
      $(".buttons_block-top").hide();
    }

    if (this.dropzone.files.length == 0) {
      this.$blockUpload.show();
      this.$list.hide();
      this.$uploadFilesHeader.hide();
      $(".buttons_block-top").hide();
      $(".buttons_block-bottom").hide();

      //just to be sure that it totaly reset
      this.notificationsReceived = 0;
      this.uuids = [];

      // also reset the file name
      $("#id_name").val("");
      $("[name=filename]").val("");
    }

    var dropzoneFileSucces = true;
    for (var j = 0; j < this.dropzone.files.length; j++) {
      if (this.dropzone.files[j].status == "error") {
        dropzoneFileSucces = false;
      }
    }

    //if there is no error
    //we go back to a mode where every files were upload and redeay to be process
    if ($("file-error").length == 0 && dropzoneFileSucces) {
      //enable the upload header with privacy/unit and upload button
      $(".upload-header").removeClass("disabled");
      //enable the add more et process buttons
      this.$buttons_block_process.removeClass("disabled");
      //restore the button in mode process your file
      $("[data-btn-process]", this.$buttons_block_process)
        .removeClass("buttons_block-process-simple")
        .html("<span class='icon-sync'></span>" + gettext("Next"));
      //display the block add more design
      $(".buttons_block-addmore", this.$blockButtons).show();
      //display the remove button on every file
      $(".upload_file-remove a").show();

      //reset notificationReceived
      this.notificationsReceived = 0;

      for (var j = 0; j < this.dropzone.files.length; j++) {
        //restore the file in an mode of uploaded 100%
        var $row = $(this.dropzone.files[j].previewTemplate);
        $(".upload-message", $row)
          .html(gettext("Loaded") + "<span class='icon-check'></span>")
          .removeClass("processing-animation");
        $(".upload-progress-bar-pct", $row)
          .width("100%")
          .removeClass("processing");
        $(".upload-pct", $row).html("100%");
      }
    }
  };

  /**
   * Dropzone file uploaded success.
   * Updates hidden field for success
   *
   * @param {object} file
   * @param {string} response - JSON raw response from server
   */
  UploadController.prototype.onFileUploaded = function (file, response) {
    var nb_multiup_file = 0;
    var error_multi_upload = gettext(
      "It is not possible to load more than one file at a time for laser cutting"
    );

    // No multi-upload for laser cutting [WD-1355]
    var dropzone = this.dropzone;
    if (this.fileUpload > 0) {
      switch (file.type) {
        case "image/svg+xml":
        case "application/illustrator":
        case "application/vnd.corel-draw":
        case "image/x-eps":
          for (var i = 1; i < dropzone.files.length; i++) {
            this.setFileModeError(
              $(dropzone.files[i].previewTemplate),
              error_multi_upload
            );
            dropzone.files[i].status = "error";
            dropzone.files[i].statusError = "multi-upload";
          }
          return;
      }
    }

    // When removing a file from upload panel, reactivate a file in multi-upload error state if possible
    var that = this;
    $(".text-link--delete").click(function (el) {
      for (var i = 0; i < dropzone.files.length; i++) {
        var file = dropzone.files[i];
        // Count files in multi-upload error state
        var nbErrors = dropzone.files.filter(function (obj) {
          return obj.statusError === "multi-upload";
        }).length;
        // if file state is set to multi-upload error
        if (file.status === "error" && file.statusError === "multi-upload") {
          // if all files are in multi-upload error state, or if the file is the last item, or if this is the last error
          if (
            nbErrors == 0 ||
            nbErrors === dropzone.files.length ||
            dropzone.files.length === 1
          ) {
            dropzone.files[i].status = "success";
            delete file.statusError;
            that.setFileModeSuccess($(dropzone.files[i].previewTemplate));
            break;
          }
        }
      }
    });

    if (file.type == "import_progress") {
      $(".upload-file-size-remaining", $row).fadeOut();
      $(".upload-file-size-remaining", $row).next().fadeOut();
      $(".upload-time-remaining", $row).fadeOut();
      return;
    }
    var $row = $(file.previewTemplate);

    // Updates hidden file IDS
    if (file.s3Data) {
      this.uuids.push(file.s3Data.key);
      this.$uuids.val(this.uuids.join(","));
    } else {
      this.uuids.push(JSON.parse(response).key);
      this.$uuids.val(this.uuids.join(","));
    }

    // Update progress text
    $(".upload-message", $row).html(
      gettext("Loaded") + "<span class='icon-check'></span>"
    );
    $(".upload-file-size-remaining", $row).fadeOut();
    $(".upload-file-size-remaining", $row).next().fadeOut();
    $(".upload-time-remaining", $row).fadeOut();

    this.fileUpload++;

    //if the total file is equal to the number of files uploaded we enable the button process files
    if (this.fileUpload == $(".upload_file", this.$list).length - 1) {
      this.$buttons_block_process.removeClass("disabled");
    }
  };

  /**
   * Dropzone file progress.
   * Updates progress bar, percentage & remaining time
   *
   * @param {object} file
   * @param {float} progress
   */
  UploadController.prototype.onFileProgress = function (
    file,
    progress,
    byteSent
  ) {
    //avoiding weird behavior for not uploaded files (here file is a notification)
    if (file.type == "import_progress") return;
    var $row = $(file.previewTemplate);

    // ticket 5642. Avoid the progress to go over 9000... 100%
    if (progress > 100) {
      progress = 100;
    }

    // Computing remaining time
    var received = (progress * file.size) / 100;
    var timeLeft =
      ((file.size - received) * (new Date().getTime() - file.startTime)) /
      received;
    var timeLeftStr = "";

    if (timeLeft > 120000) {
      timeLeftStr = Math.round(timeLeft / 60000) + " min";
    } else {
      timeLeftStr = Math.round(timeLeft / 1000) + " s";
    }

    // Updating data
    $(".upload-pct", $row).html(progress.toFixed(1) + "%");
    $(".upload-progress-bar-pct", $row).width(progress + "%");
    $(".upload-time-remaining", $row).text("~" + timeLeftStr);

    var filesizeRemaining =
      ((progress / 100) * file.size) / this.options.filesizeBase; // Bytes to K(i)B
    if (file.size > this.options.filesizeBase) {
      // K(i)B to M(i)B
      filesizeRemaining = filesizeRemaining / this.options.filesizeBase;
    }

    filesizeRemaining = filesizeRemaining.toFixed(1);

    $(".upload-file-size-remaining", $row).text(filesizeRemaining);
  };

  /**
   * Dropzone file error.
   * Display error messages and put the file in error mode
   *
   * @param {object} file
   * @param {string} error
   */
  UploadController.prototype.onFileError = function (file, error) {
    //the total progress has no extension not looking for errors
    if (file.total_progress) return;

    var $row = $(file.previewTemplate);

    var errorMessage = "";
    if (!file.xhr) {
      // this is a dropzone client side error
      // use the dropzone message
      errorMessage = error;
    } else {
      // this is a server error, 'error' would contain the html response
      // and dropzone dictResponseError isn't working
      // use a default server error message
      errorMessage = gettext(
        "Unexpected error. Please try again or contact the support. ({{statusCode}})"
      );
      errorMessage = errorMessage.replace("{{statusCode}}", file.xhr.status);
      if (Sentry) {
        Sentry.captureException(new Error(errorMessage), {
          contexts: {
            request: file.xhr,
            s3Data: file.s3Data,
          },
        });
      }
    }

    // set the file template in error mode
    this.setFileModeError($row, errorMessage);
  };

  UploadController.prototype.setErrors = function (mlog) {
    for (var key in this.knownFiles) {
      var $row = this.knownFiles[key];
      var flog = mlog.file_names[$row._name];
      if (flog && flog.archive) {
        var $archiveRow = this.archives[flog.archive];
        for (var k in flog.error) {
          this.setFileModeError($archiveRow, $row._name + ": " + flog.error[k]);
        }
      }
      if ($row.alreadyFailed) continue;
      if (flog && typeof flog.error == "string") {
        this.setFileModeError($row, flog.error);
      } else if (flog) {
        for (var k in flog.error) {
          this.setFileModeError($row, flog.error[k]);
        }
      }
    }
  };

  UploadController.prototype.process = function () {
    this.fileCount = $(".dz-success").length;

    this.notificationsReceived = 0;

    $(".upload-pct").html("0%");
    $(".upload-progress-bar-pct").width("0%").addClass("processing");
    $(".upload-message").html(
      gettext("Waiting") + "<span class='loading-circle'></span>"
    );

    //Disabled all the top part on the page. Visiblity and unit, upload buttons...
    $(".upload-options").addClass("disabled");

    //hide buttons upload
    this.$blockUpload.hide();

    //hide removed button
    $(".upload_file-remove a").hide();

    //hide the add more design when we're processing the files
    $(".buttons_block-addmore", this.$blockButtons).hide();

    //disable the button + add animation

    $(".next-upload").addClass("processing-active");
    this.$buttons_block_process
      .addClass("disabled")
      .addClass("processing-animation");

    $("[data-btn-process]", this.$buttons_block_process)
      .addClass("buttons_block-process-simple")
      .html(gettext("Wait while we process your design"));

    //showing back the archive, this what clients
    //uploaded
    for (var key in this.archives) {
      var $archiveRow = this.archives[key];
      $archiveRow.show();
    }
    var _knownFiles = {};
    //restarting from fresh state
    for (var key in this.knownFiles) {
      var $row = this.knownFiles[key];
      if ($row.automaticRow) {
        $row.remove();
        continue;
      }
      _knownFiles[$row._name] = $row;
    }
    this.knownFiles = _knownFiles;

    $.post(
      this.$form.attr("action"),
      this.$form.serialize(),
      function (res) {
        if (res.errors) {
          for (var e in res.errors) {
            if (
              res.error_code &&
              (res.error_code == "not_supported" ||
                res.error_code == "not_supported_medical")
            ) {
              var name = res.error_detail.filename;
              var $row = $(".upload_file")
                .toArray()
                .filter(function (el) {
                  return $(el).data("name") == decodeURI(name);
                })[0];
              $row = $($row);
              var msg = error_messages[res.error_code];
              msg = msg.replace(/{{(.+)}}/, function (match, key) {
                if (key in res.error_detail) {
                  return res.error_detail[key];
                } else {
                  console.log("not found " + match);
                  return key;
                }
              });
              this.setFileModeError($row, msg);
            } else if (res.errors.hasOwnProperty(e)) {
              $(".global-error-message").show();
            }
          }

          return;
        }
        if (res.uuid) this.rootUUID = res.uuid;

        sculpteoJob(res.jobs)
          .progress(function (job, msg) {
            //console.log('Progress', job, msg);
          })
          .done(function (job, msg) {
            //console.log('Done', job, msg);
          })
          .success(
            function (job, msg) {
              //removed every message on other file
              $(".upload_file-notification-message").empty();

              var mlog = msg.log || { error: [], info: [], warning: [] };

              if (mlog.error.length != 0) {
                //showing back the archive, this what clients
                //uploaded
                for (var key in this.archives) {
                  var $archiveRow = this.archives[key];
                  $archiveRow.show();
                }
                //hiding automatically created files
                //for(var key in this.knownFiles){
                //var $automaticRow = this.knownFiles[key];
                //if($automaticRow.automaticRow){
                //$automaticRow.remove();
                //}
                //}
                //if there is only one file
                if (this.fileUpload == 1) {
                  this.setFileModeError(
                    $(this.dropzone.files[0].previewTemplate),
                    mlog.error[0]
                  );
                  if (mlog.file_names) this.setErrors(mlog);
                } else if (mlog.file_names) {
                  this.setErrors(mlog);
                } else {
                  var fileName = mlog.file_name;
                  for (var i = 0; i < this.dropzone.files.length; i++) {
                    if (this.dropzone.files[i].name == fileName) {
                      var $row = $(this.dropzone.files[i].previewTemplate);
                      for (var k in mlog.error) {
                        this.setFileModeError($row, mlog.error[k]);
                      }

                      this.$buttons_block_process
                        .addClass("disabled")
                        .removeClass("processing-animation");
                      $(".btn-text-content", this.$buttons_block_process).text(
                        gettext("Next")
                      );
                    }
                  }
                }
              } else {
                this.$buttons_block_process.addClass("disabled");
                $("[data-btn-process]", this.$buttons_block_process)
                  .addClass("buttons_block-process-simple")
                  .html(
                    "<span class='loading-circle'></span>" +
                      gettext(
                        "Please wait, you will be redirected in a seconde"
                      )
                  );

                if (msg.new_redirect) {
                  var uuid_redirect = msg.new_redirect;
                } else {
                  var uuid_redirect = res.uuid;
                }

                // If there is a theme, we redirect to the appropriate page
                if (window.theme != "") {
                  var re = new RegExp(window.URL_PREFIX);
                  var themed_prefix =
                    window.URL_PREFIX + "t/" + window.theme + "/";
                  URLS.designs_upload_redirect =
                    URLS.designs_upload_redirect.replace(re, themed_prefix);
                }

                var url = $.param.querystring(
                  URLS.designs_upload_redirect + uuid_redirect,
                  $.deparam.querystring()
                );
                window.location = url;
              }
            }.bind(this)
          )
          .failure(function (job, msg) {
            //console.log('Failure', job, msg);
          });
      }.bind(this)
    );
  };

  UploadController.prototype.getRow = function (msg) {
    if (!(msg.name && msg.uuid)) return false;
    var $row = this.knownFiles[msg.name + msg.uuid];
    //we know it and design uuids match
    if ($row) {
      return $row;
    }
    $row = this.knownFiles[msg.name];
    //we know something is name msg.name, but
    //it is not attached to a design, attaching it
    if ($row) {
      //so that it is not reused
      delete this.knownFiles[msg.name];
      this.knownFiles[msg.name + msg.uuid] = $row;
      return $row;
      //we don't know, create it
    } else {
      return false;
    }
  };

  UploadController.prototype.onProcessNotification = function (msg, data) {
    //this ensures that the message identifies itself as children
    //of the design that was created on upload, its uuid is rootUUID
    var valid_notification =
      this.rootUUID &&
      (msg.uuid == this.rootUUID || msg.parent_uuid == this.rootUUID);
    //this is a stray notification
    if (!valid_notification) return;
    var $row = this.getRow(msg);
    //this messages references a file we don't know
    //create a loading bar.
    if (msg.name && !$row) {
      //bypassing dropzone max files so that I can
      //show as many as I want
      this.dropzone.options.maxFiles += 1;
      //monkey patching
      //I want the message to appear as having the same
      //interface as a file so that template rendering works
      //the same way
      if (msg.size) {
        msg.upload = { progress: 100, byteSent: msg.size, total: msg.size };
      }
      //manually adding the file to dropzone (this calls our callbacks)
      this.dropzone.addFile(msg);
      $row = this.getRow(msg);
      //Making the file looks as if it was uploaded and waiting to process
      $(".upload-pct", $row).html("0%");
      $(".upload-progress-bar-pct", $row).width("0%").addClass("processing");
      $(".upload-message", $row).html(
        gettext("Waiting") + "<span class='loading-circle'></span>"
      );
      $(".upload-file-size-remaining", $row).fadeOut();
      $(".upload-file-size-remaining", $row).next().fadeOut();
      $(".upload-time-remaining", $row).fadeOut();
      //cannot remove automatically created file
      $(".upload_file-remove a", $row).hide();
      //I am no longer sending the total progress message,
      //but It should be on top
      if (msg.total_progress) {
        var fileParent = $row.parent();
        var header = $(".upload-files-header", fileParent);
        $row.insertAfter(header);
      }
      //marking the notification as an automatic one
      $row.automaticRow = true;
      $row.remove = function () {
        this.dropzone.removeFile(msg);
      }.bind(this);
    }
    //percentage are returned by message, appart from zip extraction
    //they references the file they are attached too
    var filePct = msg.percent;
    if (msg.error && !$row.alreadyFailed) {
      for (var k in msg.message) {
        this.setFileModeError($row, msg.message[k]);
      }
      $row.alreadyFailed = true;
      return;
    }
    if (msg.extract) {
      //The row is an archive, remembering it
      this.archives[msg.name] = $row;
    }
    if (msg.extracting) {
      //Updating zip files with a progress (the same for all zip)
      //this is not the best
      var $archiveRow = this.archives[msg.archive];
      $(".upload-pct", $archiveRow).html(filePct.toFixed(1) + "%");
      $(".upload-progress-bar-pct", $archiveRow).width(filePct + "%");
      //These messages are recieved when the import job is looking for
      //models, the import process is not started yet
      filePct = 0;
    }
    //zip extraction is done, removing the zips so that the page
    //looks as if you dragged and dropped several files
    if (msg.extracted) {
      for (var key in this.archives) {
        $row = this.archives[key];
        $row.hide();
      }
      return;
    }
    if (filePct) $row.filePct = filePct;
    //this.notificationsReceived++;

    //var fileIdx = Math.floor((this.notificationsReceived-1) / 4); // we receive 4 notifications per file.
    //var filePct = this.notificationsReceived % 4 * 25 || 100;

    //var $row = $($('.dz-success').get(fileIdx));

    $(".upload-message", $row)
      .html(gettext("Processing") + "<span class='icon-sync'></span>")
      .addClass("processing-animation");
    $(".upload-pct", $row).html($row.filePct.toFixed(1) + "%");
    $(".upload-progress-bar-pct", $row).width(filePct + "%");

    //removed every message on other file
    $(".upload_file-notification-message", $row).empty();
    //hide message on the processing file
    $(".upload_file-notification-message", $row).html(msg.message);

    if (filePct === 100) {
      $(".upload-message", $row).html(gettext("Ready"));
    }
  };

  UploadController.prototype.showUploadBlock = function () {
    this.$blockUpload.toggle();
    this.onDrop = false;
  };

  /**
   * update the print_authorization when changing the privacy
   * private we show the checkbox
   * public we hide it
   */
  UploadController.prototype.uploadOptionsPrivacyChanged = function (evt) {
    if (
      $("input[type=radio][name=privacy]:checked", this.$uploadHeader).val() ==
      "f"
    ) {
      $("#id_print_authorization", this.$uploadHeader).prop("checked", true);
      $("#id_print_authorization", this.$uploadHeader).attr("disabled", true);
      $("#id_print_authorization", this.$uploadHeader).attr(
        "data-gtm-value",
        1
      );
    } else {
      $("#id_print_authorization", this.$uploadHeader).prop("checked", false);
      $("#id_print_authorization", this.$uploadHeader).attr("disabled", false);
      $("#id_print_authorization", this.$uploadHeader).attr(
        "data-gtm-value",
        0
      );
    }
  };

  /**
   * set a file in error mode
   * display error + warning icon
   * hide remaining file size and time
   */
  UploadController.prototype.setFileModeError = function (row, errorMessage) {
    var $row = row;
    $row.addClass("file-error");

    $(".upload-message", $row)
      .html(gettext("Error") + "<span class='icon-warning'></span>")
      .removeClass("processing-animation");
    $(".upload-file-size-remaining", $row).fadeOut();
    $(".upload-file-size-remaining", $row).next().fadeOut();
    $(".upload-time-remaining", $row).fadeOut();

    $(".upload_file-error-message", $row).html(errorMessage);

    //add specific class to the remove button on the file with the error
    //the button will be always red
    $(".upload_file-remove a", $row)
      .addClass("upload_file-remove-error")
      .show();
  };

  /**
   * Remove error mode from a file
   */
  UploadController.prototype.setFileModeSuccess = function (row) {
    var $row = row;
    $row.removeClass("file-error");

    $(".upload-message", $row).html(gettext("Ready"));
    $(".upload_file-error-message", $row).hide();
    $(".upload_file-remove a", $row)
      .removeClass("upload_file-remove-error")
      .show();

    this.$buttons_block_process.removeClass("disabled");
  };
})((window.sculpteo = window.sculpteo || {}));
